import React from 'react';
import { Link } from 'react-router-dom';
import { SOLUTIONS } from '../content/solutions';

const serif = { fontFamily: '"DM Serif Display", Georgia, serif' };

const LandingFooter = () => (
  <footer style={{ background: '#0d1117', color: 'rgba(255,255,255,.6)', padding: '60px 5% 32px' }}>
    <div style={{ maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 1fr', gap: 40, marginBottom: 48 }}
           className="footer-top-grid">
        {/* Brand */}
        <div>
          <div style={{ ...serif, fontSize: 22, color: '#fff', display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
            DigiHR<span style={{ width: 8, height: 8, borderRadius: '50%', background: '#1a5fff', display: 'inline-block' }} />
          </div>
          <p style={{ fontSize: 13, lineHeight: 1.7, maxWidth: 240 }}>India's all-in-one HRMS platform. GPS attendance, payroll, leave, performance, L&D and more — in one place.</p>
        </div>
        {/* Product */}
        <div>
          <h4 style={{ fontSize: 13, fontWeight: 600, color: '#fff', marginBottom: 14 }}>Product</h4>
          <ul style={{ listStyle: 'none' }}>
            {[['Features', '/features'], ...SOLUTIONS.map(s => [s.nav, `/${s.slug}`]), ['Pricing', '/pricing'], ['Book a demo', '/contact']].map(([l, h]) => (
              <li key={l} style={{ marginBottom: 2 }}>
                <Link to={h} style={{ display: 'inline-block', padding: '7px 0', fontSize: 14, color: 'rgba(255,255,255,.5)', textDecoration: 'none' }}
                      onMouseEnter={e => e.target.style.color = '#fff'}
                      onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,.5)'}>{l}</Link>
              </li>
            ))}
          </ul>
        </div>
        {/* Resources */}
        <div>
          <h4 style={{ fontSize: 13, fontWeight: 600, color: '#fff', marginBottom: 14 }}>Resources</h4>
          <ul style={{ listStyle: 'none' }}>
            {[['Blog', '/blog'], ['PF, ESI & PT checklist', '/blog/pf-esi-pt-compliance-checklist'], ['GPS vs biometric', '/blog/gps-attendance-vs-biometric'], ['HRMS vs Excel', '/blog/hrms-vs-excel']].map(([l, h]) => (
              <li key={l} style={{ marginBottom: 2 }}>
                <Link to={h} style={{ display: 'inline-block', padding: '7px 0', fontSize: 14, color: 'rgba(255,255,255,.5)', textDecoration: 'none' }}
                      onMouseEnter={e => e.target.style.color = '#fff'}
                      onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,.5)'}>{l}</Link>
              </li>
            ))}
          </ul>
        </div>
        {/* Company */}
        <div>
          <h4 style={{ fontSize: 13, fontWeight: 600, color: '#fff', marginBottom: 14 }}>Company</h4>
          <ul style={{ listStyle: 'none' }}>
            {[['About us', '/about'], ['Careers', '/careers'], ['Privacy Policy', '/privacy-policy'], ['Terms of Service', '/terms'], ['Delete Account', '/delete-account'], ['Login', '/login']].map(([l, h]) => (
              <li key={l} style={{ marginBottom: 2 }}>
                <Link to={h} style={{ display: 'inline-block', padding: '7px 0', fontSize: 14, color: 'rgba(255,255,255,.5)', textDecoration: 'none' }}
                      onMouseEnter={e => e.target.style.color = '#fff'}
                      onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,.5)'}>{l}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div style={{ borderTop: '1px solid rgba(255,255,255,.08)', paddingTop: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: 12 }}>
        <span>© {new Date().getFullYear()} DigiHR </span>
        <div style={{ display: 'flex', gap: 8 }}>
          {['India-compliant', 'SOC 2', 'GDPR'].map(t => (
            <span key={t} style={{ padding: '4px 12px', borderRadius: 100, border: '1px solid rgba(255,255,255,.12)', fontSize: 12, color: 'rgba(255,255,255,.4)' }}>{t}</span>
          ))}
        </div>
      </div>
    </div>
    <style>{`
      @media(max-width:768px){
        .footer-top-grid{ grid-template-columns:1fr 1fr !important; }
      }
    `}</style>
  </footer>
);

export default LandingFooter;
